import { Button } from '@mui/material';

// interface IconButtonProps {}

export const IconButton = ({
  onClick,
  endIcon,
  startIcon,
  text,
  variant = 'text',
}: any) => {
  return (
    <Button variant={variant} onClick={onClick} startIcon={startIcon}>
      {text}
    </Button>
  );
};
